import { restaurantPropTypes } from '@nandosaus/prop-types';
import React from 'react';

import { Col, Container, Row } from '../grid';
import { RestaurantInformationHeader } from '../restaurant-information-header';
import { RestaurantOpeningHoursTable } from './restaurant-opening-hours-table';

const RestaurantDetailsTables = ({ restaurant }) => {
  const tableWidth = { xs: 1, md: 6 / 12 };

  return (
    <Container>
      <Row>
        <Col width={{ xs: 1, md: 10 / 12 }} offset={[0, 0, 1 / 12]}>
          <Row flexWrap="wrap">
            <RestaurantInformationHeader {...{ restaurant }} />
            <Col width={tableWidth}>
              <RestaurantOpeningHoursTable
                openingHours={restaurant.openingHours}
                formattedTradingHours={restaurant.formattedTradingHours}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

RestaurantDetailsTables.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
};

export { RestaurantDetailsTables };
